import React from 'react'
import { Toaster } from 'react-hot-toast'
import Navbar from '../components/Navbar/Navbar'
import Sidebar from '../components/Sidebar/Sidebar'
import Dashboard from '../components/Dashboard/Dashboard'

const Home = () => {
  return (
    <div>
        <div className="App">
          
          <Toaster />
         
          <Navbar />
          <div className='sidebar-dashboard-container'>
            <Sidebar />
            <div className='dashboard-container'>
              <Dashboard />
              </div>
          </div>
        </div>
    </div>
  )
}

export default Home
